import type { Theme } from '@mui/material/styles';

const Popover = (theme: Theme) => {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: Number(theme.shape.borderRadius) * 1.5,
          boxShadow: theme.customShadows.dropdown,
        },
      },
    },
  };
};

export default Popover;
